import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VoiceOverOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"voice_over_off"}/>
}
